import { cn } from "@/lib/utils"
import { ReactNode } from "react"

interface GlassCardProps {
  children: ReactNode
  className?: string
  hover?: boolean
}

export function GlassCard({ children, className, hover = true }: GlassCardProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-white/10 bg-white/5 backdrop-blur-md",
        "shadow-lg shadow-black/20",
        hover && "transition-all duration-300 hover:bg-white/[0.07] hover:shadow-xl hover:shadow-black/30",
        className
      )}
    >
      {children}
    </div>
  )
}

